import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

const CategoriaDeleteConfirm = ({ 
  show, 
  onHide, 
  onConfirm, 
  categoria, 
  loading,
  productosCount = 0 
}) => {
  const canDelete = productosCount === 0;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fas fa-exclamation-triangle text-warning me-2"></i>
          Confirmar Eliminación
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {canDelete ? (
          <>
            <p className="mb-3">
              ¿Estás seguro de que deseas eliminar la categoría{' '}
              <strong>"{categoria?.nomCategoria}"</strong>?
            </p>
            <Alert variant="warning" className="mb-0">
              <i className="fas fa-info-circle me-2"></i>
              Esta acción no se puede deshacer.
            </Alert>
          </>
        ) : (
          <>
            <Alert variant="danger">
              <i className="fas fa-ban me-2"></i>
              <strong>No se puede eliminar esta categoría</strong>
            </Alert>
            <p className="mb-3">
              La categoría <strong>"{categoria?.nomCategoria}"</strong> tiene{' '}
              <strong>{productosCount} producto{productosCount !== 1 ? 's' : ''}</strong> asociado{productosCount !== 1 ? 's' : ''}.
            </p>
            <Alert variant="info" className="mb-0">
              <i className="fas fa-lightbulb me-2"></i>
              <strong>Sugerencia:</strong> Reasigna los productos a otra categoría antes de eliminar esta.
            </Alert>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          {canDelete ? 'Cancelar' : 'Cerrar'}
        </Button>
        {canDelete && (
          <Button 
            variant="danger" 
            onClick={onConfirm} 
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Eliminando...
              </>
            ) : (
              <>
                <i className="fas fa-trash me-2"></i>
                Eliminar Categoría
              </>
            )}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default CategoriaDeleteConfirm;
